module.exports = __webpack_public_path__ + "static/img/room_img1.9da10af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/room_img1.png
// module id = vVJg
// module chunks = 0